export const NewTesEmployeeGetters = {
  NewTesEmployee: 'getNewTesEmployee'
};
